import { Component, OnInit, ViewChild } from '@angular/core';
import { CardDealService } from '../card-deal.service';
import { Global } from '../classes/Global';
import { AuthenticationService } from '../authentication.service';
import { StorageHelper } from '../helpers/StorageHelper';
import { InfiniteScrollComponent } from '../classes/InfiniteScrollComponent';
import { NotificationSettingsService } from '../notification-settings.service';
import { GlobalService } from '../global.service';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-gift-cards',
  templateUrl: './gift-cards.component.html',
  styleUrls: ['./gift-cards.component.scss'],
  providers: [ CardDealService, AuthenticationService, NotificationSettingsService ]
})
export class GiftCardsComponent extends InfiniteScrollComponent implements OnInit {
  
  @ViewChild('header', {static: false}) header;
  @ViewChild('newCardDealPopup', {static: false}) newCardDealPopup;
  @ViewChild('toggleSwitch', {static: false}) toggleSwitch;
  
  cardDeals: any = [];
  newlyCommentedDeal = null;

  shippingTypes = [
    { key: '', value: this.getString('all') },
    { key: '1', value: this.getString('digitalDelivery') },
    { key: '2', value: this.getString('physical') }
  ];
  shippingType = this.shippingTypes[0];
  emailNotificationsActive: boolean = false;
  mailSettings: any = {};

  constructor(
    private cardDealService: CardDealService,
    private authenticationService: AuthenticationService,
    private notificationSettingsService: NotificationSettingsService,
    private globalService: GlobalService,
    private route: ActivatedRoute
  ) {
    super();
  }

  ngOnInit() {

    StorageHelper.getInstance().save(StorageHelper.keys.store, Global.ITUNES);
    if(this.authenticationService.isLoggedIn()) {
      this.getMailSettings();
    }

    const ngUnsubscribe: Subject<any> = new Subject();
    this.route.params.pipe(takeUntil(ngUnsubscribe)) //take values until a notifier emits a value
    .subscribe(params => {

      let countryKey = params['country'];
      if (countryKey && Global.countries[countryKey]) {
        StorageHelper.getInstance().save(StorageHelper.keys.country, countryKey);
      }
      
      this.getDeals();

      ngUnsubscribe.next();
      ngUnsubscribe.complete();

    });

  }

  loadMoreItems() {
    this.offset += this.limit;
    this.isLoading = true;
    this.cardDealService.getDeals(
      Global.getCountry(), Global.getStore(), this.shippingType.key,
      this.limit, this.offset, StorageHelper.getInstance().get(StorageHelper.keys.sessionToken)).subscribe(res => {
      if (this.cardDeals && res && res["results"] && res["results"].length > 0) {
        this.cardDeals = this.cardDeals.concat(res["results"]);
      }
      if (res && res["results"] == null || !res["results"].length || res["results"].length === 0) {
        this.resultsEndReached = true;
      }
      this.isLoading = false;
    }, err => {
      this.isLoading = false;
    });
  }

  submitDeal() {
    if(this.authenticationService.isLoggedIn()) {
      this.newCardDealPopup.open();
    }
    else {
      this.header.registerClicked();
    }
  }

  getDeals() {
    this.offset = 0;
    this.resultsEndReached = false;
    this.isLoading = true;
    this.cardDealService.getDeals(Global.getCountry(), Global.getStore(),
    this.shippingType.key, this.limit, this.offset,
    StorageHelper.getInstance().get(StorageHelper.keys.sessionToken)).subscribe(res => {
      if (res && res["results"] && res["results"].length > 0) {
        this.cardDeals = res["results"];
        this.globalService.updateNewCardDeal(false);
      }
      else {
        this.cardDeals = [];
      }
      if (res && res["results"] == null || !res["results"].length || res["results"].length === 0) {
        this.resultsEndReached = true;
      }
      this.isLoading = false;
    }, err => {
      this.cardDeals = [];
      this.isLoading = false;
    });
  }

  showRegister() {
    this.header.registerClicked();
  }

  newCommentAdded(cardDeal) {
    this.newlyCommentedDeal = cardDeal;
    this.getDeals();
  }

  showComments(deal) {
    return this.newlyCommentedDeal && this.newlyCommentedDeal.id == deal.id;
  }

  typeChanged(e) {
    if(e) {
      this.shippingType = e;
      this.getDeals();
    }
  }

  newCardDealClose(result) {
    if(result) {
      this.getDeals();
    }
    this.newCardDealPopup.close();
  }

  emailNotificationsClick(active: boolean) {
    if(this.authenticationService.isLoggedIn()) {
      this.emailNotificationsActive = active;
      this.saveMailSettings();
    }
    else {
      this.toggleSwitch.setValue(!active);
      this.header.registerClicked();
    }
  }

  getMailSettings() {
    this.notificationSettingsService.getMailFlags(StorageHelper.getInstance().get(StorageHelper.keys.sessionToken), Global.getCountry()).subscribe(res => {
      if(res && res["mailNotificationSettings"]) {
        this.mailSettings = res["mailNotificationSettings"];
        this.emailNotificationsActive = this.mailSettings["cardDeals"];
      }
    }, err => {
    });
  }

  saveMailSettings() {
    let dealFlags: string = "";
    if(this.mailSettings["music"]) { dealFlags += "1"; } else { dealFlags += "0"; }
    if(this.mailSettings["movies"]) { dealFlags += "1"; } else { dealFlags += "0"; }
    if(this.mailSettings["tv"]) { dealFlags += "1"; } else { dealFlags += "0"; }
    if(this.mailSettings["audiobooks"]) { dealFlags += "1"; } else { dealFlags += "0"; }
    if(this.mailSettings["ebooks"]) { dealFlags += "1"; } else { dealFlags += "0"; }
    if(this.mailSettings["apps"]) { dealFlags += "1"; } else { dealFlags += "0"; }
    if(this.mailSettings["macapps"]) { dealFlags += "1"; } else { dealFlags += "0"; }

    //For new API
    let flags: string = "";
    if(this.emailNotificationsActive? true : this.mailSettings["globalEnabled"]) { flags += "1"; } else { flags += "0"; }//globalEnabled
    if(this.mailSettings["wishlist"]) { flags += "1"; } else { flags += "0"; }//wishlist
    if(this.mailSettings["radar"]) { flags += "1"; } else { flags += "0"; }//radar
    if(this.mailSettings["blogEntry"]) { flags += "1"; } else { flags += "0"; }//blogEntry
    if(this.mailSettings["comment"]) { flags += "1"; } else { flags += "0"; }//comment
    if(this.emailNotificationsActive) { flags += "1"; } else { flags += "0"; }//cardDeals
    flags += dealFlags; //medias

    this.notificationSettingsService.setMailFlags(flags, StorageHelper.getInstance().get(StorageHelper.keys.sessionToken), Global.getCountry()).subscribe(res => {
      
      if(res["status"] != "success") {
        //reset with the server value
        this.getMailSettings();
      }

    }, err => {
      //reset with the server value
      this.getMailSettings();
    });
  }

}
